export const TAB_INDICES = {
  MAIL_PREVIEW: 0,
  PROPOSAL_PARAMETERS: 1,
  GUIDANCE: 2,
  SYSTEM_INTEGRATION: 3,
  CONFIRMATION: 4,
  PRICE_LIST: 5,
  DOCUMENTS: 6,
} as const;
